export default class Equipamento {
  constructor(sgcq, nome, codigo, fabricante, dimensoes, peso, carga, observacao, grupo, referencia, responsavel) {
    this.sgcq = sgcq;
    this.nome = nome;
    this.codigo = codigo;
    this.fabricante = fabricante;
    this.dimensoes = dimensoes;
    this.peso = peso;
    this.carga = carga;
    this.observacao = observacao;
    this.grupo = grupo;
    this.referencia = referencia;
    this.responsavel = responsavel;
  }

  update(eqp) {
    this.sgcq = eqp.sgcq;
    this.nome = eqp.nome;
    this.codigo = eqp.codigo;
    this.fabricante = eqp.fabricante;
    this.dimensoes = eqp.dimensoes;
    this.peso = eqp.peso;
    this.carga = eqp.carga;
    this.observacao = eqp.observacao;
    this.grupo = eqp.grupo;
    this.referencia = eqp.referencia;
    this.responsavel = eqp.responsavel;
    this.cliente = eqp.cliente;
  }
}
